import MaintenancePage from "./pages/maintenance/MaintenancePage";
import NewSpaceRedirectPage from "./pages/new-space/NewSpaceRedirectPage";

const isMaintenance = import.meta.env.VITE_MAINTENANCE === "1";

function App() {
  return isMaintenance ? <MaintenancePage /> : <NewSpaceRedirectPage />;
}

export default App;
